<template>
  <div id="app" @scroll="check_header_fix()" :class="'rtl ' + (show_side_menu ? 'menu_open' : '')">
    
    <div id="side_menu" v-if="is_mobile()">


				<i class="material-icons dp48" @click="open_search()">search</i>

        <ul class="sharing_list">
          <li id="fc_white"><a href="http://www.facebook.com/Hidabroot" target="_blank"></a></li>
          <li id="whatsapp_white"><a href="http://lp.vp4.me/b11r" target="_blank"></a></li>
          <li id="instagram_white"><a href="https://www.instagram.com/hidabroottv" target="_blank"></a></li>
          <li id="android_white"><a href="https://play.google.com/store/apps/details?id=net.linnovate.hidabroot" target="_blank"></a></li>
          <li id="itunes_white"><a href="https://itunes.apple.com/il/app/%D7%94%D7%99%D7%93%D7%91%D7%A8%D7%95%D7%AA/id1006747141?mt=8" target="_blank"></a></li>
        </ul>
        
        <ul>
          <li v-for="menu_item in menu" :key="menu_item.id"><a :href="menu_item.link" :target="(menu_item.target != '' ? menu_item.target : '')" :style="(menu_item.color != '' ? 'color:#' + menu_item.color : '')"><span class="material-icons">{{menu_item.icon}}</span>{{ menu_item.name }}</a></li>
        </ul>

    </div>

    <main id="page-wrap">

      <div id="menu_hamburger"  v-if="is_mobile()" v-on:click="show_side_menu=!show_side_menu">
        <div id="nav-icon3"><span></span><span></span><span></span><span></span></div>
      </div>

      <TovHeader :class="header_class" :user_data="user_data" :profile="profile" :menu="menu" />
      <div id="page_content">
        <LoginPage v-if="show_login" />
        <router-view v-if="!show_login" :key="$route.path" :user_data="user_data" :profile="profile" ></router-view>
      </div>
    </main>
  </div>
</template>

<script>
import TovHeader from './components/header.vue'
import LoginPage from './components/login.vue'

window.api_url = 'https://pisgalive2020.nadlancenter.co.il/api_vue/'; 

export default {
  name: 'app',
  components: {
    'TovHeader': TovHeader,
    'LoginPage': LoginPage,
  },
  data(){
    return {
      header_class: '',
      user_data: {},
      profile: {},
      menu: [],
      show_login: false
    }
    
  },
  methods: {

    parse_user_channel(msg)
    {
      var data = JSON.parse(msg.message);
      console.log(data);

      switch(data.mtype)
      {
        case 'login': { 
          localStorage.setItem('user_token', '');
          alert('משתמש אחר התחבר דרך פרטי החשבון שלך. המחשב שלך יתונק כעת מהאתר.');
          document.location = '/';
          break; 
        }
      }
    },

  },
  created() {

    var self = this;

    // categories 
    this.api_call({ url: 'general', onComplete: function(data){

      self.user_data = data.data.data.user;
      self.menu = data.data.data.menu;
      if (!self.isNull(data.data.data.profile)) self.profile = data.data.data.profile;

      self.$store.state.profiles = self.user_data.profiles;
      self.$store.state.restrictions = data.data.data.restrictions;

      if (!(self.user_data.id > 0))
      {
        //self.$router.push("login");
        self.show_login = true;
      }
      else
      {
        self.$pnSubscribe({ channels: ['user_cnl_' + self.user_data.id] });
        self.$pnGetMessage('user_cnl_' + self.user_data.id, self.parse_user_channel);
      }
    } } );

  }
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Heebo&display=swap');
@import url('https://fonts.googleapis.com/icon?family=Material+Icons');

</style>